import { render, staticRenderFns } from "./Striped.vue?vue&type=template&id=63358f26&"
import script from "./Striped.vue?vue&type=script&lang=ts&"
export * from "./Striped.vue?vue&type=script&lang=ts&"
import style0 from "./Striped.vue?vue&type=style&index=0&id=63358f26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports